import { constants } from './reporting-color.constant'

import { createSelector } from '@/factory'

const getColorSettingsBlock = () => createSelector<HTMLElement>({ selector: constants.selector.settingColor })

const getColorSettingContainers = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: constants.selector.colorContainers }, true)

export const getReportingColorSettingSelectors = () => {
	const colorSettingsBlock = getColorSettingsBlock()
	const colorSettingContainers = getColorSettingContainers(colorSettingsBlock)

	return { colorSettingsBlock, colorSettingContainers }
}

export const getReportingColorAndValueByContainer = (scope?: HTMLElement) => {
	const color = createSelector<HTMLElement>({ scope, selector: constants.selector.colorPicker })
	const value = createSelector<HTMLElement>({ scope, selector: constants.selector.colorValue })

	return { color, value }
}
